import type { RemovalTagRecord } from '@avisoma/shared';

const FIELD_LABELS: ReadonlyArray<[keyof RemovalTagRecord, string]> = [
  ['partNumber', 'Part Number'],
  ['serialNumber', 'Serial Number'],
  ['kind', 'Tag Kind'],
  ['date', 'Date'],
  ['dateRaw', 'Date (as printed)'],
  ['workOrder', 'Work Order'],
];

/**
 * One part tag from a `Removal Tags` page (DR-5137) — the tag's part and serial number, its kind
 * (serviceable / unserviceable / removal / external-repair), date and work order as a label grid.
 * Same card shell as the page's flight-log card. Renders nothing when the record is empty.
 */
export function RemovalTagCard({ record }: { record: RemovalTagRecord }) {
  const entries = FIELD_LABELS.flatMap(([key, label]) => {
    const value = record[key];
    return value == null ? [] : [[label, String(value)] as const];
  });
  if (entries.length === 0) return null;
  return (
    <div className="bg-white dark:bg-zinc-800 shadow dark:shadow-zinc-950/30 rounded-lg overflow-hidden border border-gray-200 dark:border-zinc-700">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-zinc-700">
        <h2 className="text-sm font-medium text-gray-900 dark:text-zinc-100">Removal Tag</h2>
      </div>
      <div className="px-4 py-4">
        <dl className="grid grid-cols-3 gap-4">
          {entries.map(([label, value]) => (
            <div key={label}>
              <dt className="text-sm font-medium text-gray-500 dark:text-zinc-400">{label}</dt>
              <dd className="mt-1 text-sm text-gray-900 dark:text-zinc-100">{value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
